import { PagingResultsViewModel, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class ProgramaVerificacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: ProgramaVerificacionItemViewModel[];
}

export class ProgramaVerificacionItemViewModel {
    public IdProgramaVerificacion: number;
    public Campania: string;
    public Periodo: string;
    public ComunidadAutonoma: string;
    public EntidadAuditora: string;
    public IdEstadoPv: number;
    public EstadoPv: string;
    public FechaPresentacion: Date | null;
    public FechaAdmision: Date | null;
    public FechaDevolucion: Date | null;
    public EsVisibleEdicion: boolean;
}

export class FilterSearchingProgramaVerificacionViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;
    constructor() {
        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.FechaPresentacionDesde = this.firstDayMonth;
        this.FechaPresentacionHasta = this.lastDayMonth;
    }

    public listIdEstados: number[] = [];
    public IdCampania: number | null;
    public IdCa: number | null;
    public FechaPresentacionDesde: Date | null;
    public FechaPresentacionHasta: Date | null;
    public IdUsuario = 0;
    public EsAdmin: boolean;
    public EsEntidadAuditora: boolean;
    public EsComunidadAutonoma: boolean;
}
